import React from "react";
import { Button, Stack, FormControl, InputLabel, OutlinedInput } from "@mui/material";
import Modal, { CommonModalProps } from "..";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { assetService, thumbnailService } from "../../../Core/Api/services";
import { CollectionType } from "../../../Core/Api/Types/db-collection-type";
import useCollectionActions from "../../../Utils/Hooks/useCollectionActions";
import useCustomSnackbar from "../../../Utils/Hooks/useCustomSnackbar";
import { useTranslation } from "react-i18next";

type onCloseClbProps = {
  collectionName: string;
};

export type ModalCreateWishlistElementProps = {
  itemIds: number[];
  back?: boolean;
  onClose?: (clb: onCloseClbProps) => void;
};

export type ModalCreateWishlistProps = CommonModalProps<ModalCreateWishlistElementProps>;

const ModalCreateWishlist = React.forwardRef<any, ModalCreateWishlistProps>((props, ref) => {
  const collectionActions = useCollectionActions();
  const { closeModal, onClose, back = false, itemIds } = props;
  const [collectionName, setCollectionName] = React.useState("");
  const enqueueCustomSnackbar = useCustomSnackbar();
  const { t } = useTranslation();

  const handleCollectionNameChange: React.ChangeEventHandler<HTMLTextAreaElement> = (e) => {
    setCollectionName(e.target.value);
  };

  const handleCreateClick: React.MouseEventHandler = () => {
    assetService
      .CreateCollection(
        collectionName,
        "",
        CollectionType.Whishlist,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        itemIds
      )
      .then((response) => {
        if (response.success) {
          closeModal();
          onClose && onClose({ collectionName });
        } else enqueueCustomSnackbar(t("alert:error.creatingCollection", { message: response.message }), "error");
      });
  };

  /*const titleItemListData = React.useMemo(
    () =>
      items.map((item) => ({
        id: item.id,
        title: item.name,
        poster: thumbnailService.GetObjectPosterUrl(item.id, ThumbnailSize.small),
      })),
    [items]
  );*/

  return (
    <Modal
      closeModal={closeModal}
      reference={ref}
      width={504}
      title={t("modal:title.createCollection")}
      footer={
        <Stack direction="row" spacing={2}>
          {back && (
            <Button onClick={() => collectionActions.AddItemsByIdsToCollection(itemIds)}>
              <ArrowBackIcon />{" "}
            </Button>
          )}
          <Button
            variant="contained"
            onClick={handleCreateClick}
            disabled={collectionName === ""}
            startIcon={<AddIcon />}
            sx={{ flex: 1 }}
          >
            {t("button:createANewCollection")}
          </Button>
        </Stack>
      }
    >
      {/*titleItemListData.length > 0 && (
        <>
          <TitleItemList list={titleItemListData} />
          <Divider sx={{ mt: 1, mb: 2 }} />
        </>
      )*/}
      <FormControl sx={{ mb: 1 }}>
        <InputLabel shrink htmlFor="create-collection">
          {t("field:label.collectionName")}
        </InputLabel>
        <OutlinedInput
          autoFocus
          placeholder={t("field:placeholder.createCollectionName")}
          value={collectionName}
          onChange={handleCollectionNameChange}
          id="create-collection"
        />
      </FormControl>
    </Modal>
  );
});

export default ModalCreateWishlist;
